import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { Endpoints } from "src/app/shared/config/endpoints";
import { AppState } from "src/app/store/app.state";

@Injectable({
  providedIn: "root",
})
export class SalesPersonService {
  url = this.endpoints.signUpEndpoint;
  salesUrl = this.endpoints.salesUrl;
  peopleSvc = this.endpoints.peopleEndpoint;

  org;
  userID;

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.org = info.organization;
      this.userID = info.user.id;
    });
  }

  /**
   * Error Handler
   */
  private handleError = (error: any): Observable<any> => {
    let message = "";
    if (error) {
      if (error.error) {
        message = error.error.message;
      } else {
        message = error.message;
      }
    }
    return of(null);
  };

  /**
   * Get Salesperson in the organization
   * 4= all salespersons
   * 5= active salespersons
   * @param type
   */
  // catchError(this.handleError)
  fetchSalesperson(type) {
    return this.http
      .get(this.url + `/getOrganizationPersons/${this.org.id}/${type}`)
      .pipe(
        map((res: any) => {
          return res.map((result) => {
            const { user, userRel } = result;
            let response = {
              ...user,
              userRel: { ...userRel },
              name: `${user.firstName} ${user.lastName}`,
            };
            return response;
          });
        })
      );
  }
  fetchSalepersonDealsStats(type) {
    const api = this.fetchSalesperson(type).pipe(mergeMap((salespersons) => {
      const userIds = salespersons.map(salesp => salesp.id);
      const salepsDealDetails = this.fetchSalesPersonsDealsDetails(userIds).pipe(map((dealDetails) => {
        const result = [];
        dealDetails.forEach(dealDet => {
          const salepDetails = salespersons.find(salp => salp.id == dealDet.creatorID);
          result.push({
            id: salepDetails.id,
            name: `${salepDetails.firstName} ${salepDetails.lastName}`,
            email: salepDetails.email,
            totalNumberOfDeals: dealDet.detail.totalDeals,
            noOfDealsWon: dealDet.detail.wonDeals,
            noOfDealsLost: dealDet.detail.lostDeals,
            noOfDealsOpen: dealDet.detail.openDeals
          });
        })
        return result
      }));
      return salepsDealDetails
    }))
    return api
  }
  fetchSalesPersonsDealsDetails(ids: any[]) {
    const payload = [];
    ids.forEach(id => (payload.push({ creatorID: id, orgID: this.org.id })))
    return this.http.post<any[]>(`${this.salesUrl}/getCreatorsDealsDetails`, payload);
  }

  /**
   * Get Salesperson (TEAMS MODULE) in the organization
   * 4=all salespersons
   * 5=active salespersons
   * @param type
   */
  fetchMainSalesperson(type) {
    return this.http.get(
      this.url + `/getOrganizationPersons/${this.org.id}/${type}`
    );
  }


  /**
   * Fetch User/Salesperson By Id
   * @param id
   */
  fecthUser(id, type) {
    try {
      return this.http
        .get(this.url + `/getAUserDetails/${id}/${this.org.id}/${type}`)
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  /**
   * Fetch Users Group By Id
   * @param agentId
   */
  getAgentGroups(agentId) {
    return this.http.get(
      this.peopleSvc + `/getMemberGroups/${agentId}/${this.org.id}`
    );
  }

  /**
   * Update User/Salesperson
   * @param body
   */
  updateSalesPerson(body) {
    return this.http.post(this.url + "/editUser", body);
  }

  /**
   * Get  User/Salesperson Target
   * @param pId
   */
  getSalespersonTargets(pId, queryString) {
    try {
      return this.http
        .get(`${this.endpoints.targetServiceUrl}/user/user-targets/${pId}?${queryString || ''}`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  /**
   * Get Teams Target
   * @param tId
   */
  getTeamTargets(tId) {
    try {
      return this.http
        .get(`${this.endpoints.targetServiceUrl}/user/team/targets/${tId}`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  /**
   *  Get User/Salesperson Commission
   * @param pId
   */
  getSalespersonCommissions(pId) {
    try {
      return this.http
        .get(`${this.endpoints.targetServiceUrl}/user/user-commissions/${pId}`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  /**
   * Create SalesPerson Custom Filter
   * @param body
   */
  newSalesPersonCustomFilter(body) {
    const payload = { ...body, orgID: this.org.id, userID: this.userID };
    return this.http.post(this.url + "/newSalesPersonCustomFilter", payload);
  }

  /**
   * Fetch Filter
   */
  fetchFilter() {
    return this.http.get(
      this.url + `/${this.org.id}/${this.userID}/getSalesPersonCustomFilters`
    );
  }

  /**
   * Filtered SalesPerson By Number Of Invoices
   * @param data
   */
  FilteredSalesPersonsByNumberOfInvoices(data: { from; to }) {
    return this.http.get(
      this.url +
      `/${data.from}/${data.to}/${this.org.id}/FilteredSalesPersonsByNumberOfInvoices`
    );
  }

  /**
   * Filtered SalesPerson By Deal Total
   * @param data
   */
  FilteredTotalDeals(data: { from; to }) {
    try {
      return this.http
        .get(
          this.url +
          `/${data.from}/${data.to}/${this.org.id}/FilteredSalesPersonsDeals`
        )
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  /**
   * Filtered SalesPerson By Deal Won
   * @param data
   */
  FilteredDealsWon(data: { from; to }) {
    try {
      return this.http
        .get(
          this.url +
          `/${data.from}/${data.to}/${this.org.id}/FilteredSalesPersonsByNumberOfDealsWon`
        )
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  /**
   * Filtered SalesPerson By Deal Lost
   * @param data
   */
  FilteredDealsLost(data: { from; to }) {
    try {
      return this.http
        .get(
          this.url +
          `/${data.from}/${data.to}/${this.org.id}/FilteredSalesPersonsByNumberOfDealsLost`
        )
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  /**
   * Get  SalesPersons Custom Filter by ID
   * @param id
   */
  getSalesPersonCustomFilter(id) {
    return this.http.get(
      this.url +
      `/${id}/${this.org.id}/${this.userID}/getSalesPersonCustomFilter`
    );
  }

  /**
   * Get Filtered SalesPersons bY id
   * @param id
   */
  getFilteredSalesPersons(id) {
    try {
      return this.http
        .get(this.url + `/${id}/getFilteredSalesPersons`)
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  /**
   *EDIT Crew Custom Filter
   * @param Body
   */
  editFilter(body) {
    const payload = {
      filterName: body.name,
      fromNoOfDeals: body.fromNoOfDeals,
      fromNoOfDealsLost: body.fromNoOfDealsLost,
      fromNoOfDealsWon: body.fromNoOfDealsWon,
      id: body.id,
      noOfDeals: body.noOfDeals,
      noOfDealsLost: body.noOfDealsLost,
      noOfDealsWon: body.noOfDealsWon,
      orgID: this.org.id,
      userID: this.userID
    };
    return this.http.post(this.url + "/editSalesPersonCustomFilter", payload);
  }

  /**
   * Delete SalesPersons Filter By ID
   * @param id
   */
  deleteSalesPersonCustomFilter(id) {
    return this.http.delete(this.url + `/${id}/deleteSalesPersonCustomFilter`);
  }

  /**
   * Assign Sales Territory
   * @param ids
   */
  assignSalesTerritory(body) {
    const payload = [...body];
    return this.http.post(this.url + `/salespersonSalesTerritory`, payload);
  }

  /**
   *  Fetch Assign Sales Territory
   * @param salesPersonID
   */
  getAssignSalesTerritory(salesPersonID) {
    return this.http.get(
      this.url +
      `/getSalesPersonSalesTerritories/${salesPersonID}/${this.org.id}`
    );
  }

  /**
   * Delete SalesPersons SalesTerritory By ID
   * @param id
   */
  deleteSalesPersonTerritory(id) {
    return this.http.delete(
      this.url + `/removeSalespersonSalesTerritory/${id}`
    );
  }
}
